<template>
    <Marker
        :options="{ position: position, icon: icon }"
        @click="openInfoBox"
    >
        <InfoWindow
            ref="infoPopup"
            :opened="showInfo"
            :options="{ options }"
            @closeclick="closeInfoBox"
        >
            <div class="flex content-center">
                <div v-if="drain.adoptions.length > 0" >
                    <div>
                        <div class="flex text-lg text-grey-darkest">
                            <img
                                v-if="avatar"
                                class="w-16 h-16 pr-1 rounded-full"
                                :src="avatar"
                                alt="The profile picture of the user who adopted this drain."
                            />

                            <p>
                                <strong>{{ drain.adoptions[0].name }}</strong> is already adopted by <strong>{{ drain.adoptions[0].user.display_name }}</strong>.
                            </p>
                        </div>

                        <div class="pt-4 text-grey-darkest" v-if="sponsors">
                            <p>SPONSORED BY:</p>
                            <p>{{ sponsors }}</p>
                        </div>
                    </div>

                    <form method="POST" action="report/store">
                        <input type="hidden" name="drain_id" :value="drain.id" />

                        <input type="hidden" name="_token" :value="token" />

                        <button class="mt-8 text-sm text-grey-dark hover:text-red" type="submit">
                            Report Inappropriate Content
                        </button>
                    </form>
                </div>

                <div v-else>
                    <span class="text-lg">Yes, this one is adoptable!</span>

                    <form method="POST" action="adoptions/guest">
                        <input type="hidden" name="drain_id" :value="drain.id" />

                        <input type="hidden" name="_token" :value="token" />

                        <button class="w-full px-8 py-2 mt-4 font-bold rounded bg-pink-light hover:bg-pink text-grey-lightest" type="submit">
                            Adopt Drain
                        </button>

                        <div class="pt-4 text-grey-darkest" v-if="sponsors">
                            <p>SPONSORED BY:</p>
                            <p>{{ sponsors }}</p>
                        </div>
                    </form>
                </div>
            </div>
        </InfoWindow>
    </Marker>
</template>

<script>
import { InfoWindow, Marker } from "vue3-google-map";

export default {
    components: {
        InfoWindow, Marker
    },

    props: {
        drain: {},
        position: {},
        openedDrainId: { default: null },
        myDrainIds: { default: null },
        adoptedDrainIds: { default: null },
    },

    data() {
        return {
            showInfo: false,
        };
    },

    computed: {
        token() {
            return window.token.content;
        },
        avatar() {
            return this.adoptedByUser ? this.adoptedByUser.avatar_path : null;
        },
        adoptedByUser() {
            return this.drain.adoptions[0].user;
        },
        options() {
            return {
                position: this.position,
                pixelOffset: {
                    height: -35,
                    width: 0,
                },
            };
        },
        sponsors() {
            return this.drain.sponsors.map(region => {
                if (region.type == 'city') {
                    return `City of ${region.name}`;
                }

                return `${region.name} ${region.type}`;
            }).join(' | ');
        },
        icon() {
            if (this.showInfo) {
                return {
                    url: '/images/map-pin-red.png',
                    scaledSize: { width: 27, height: 39 },
                };
            }

            if (this.myDrainIds.includes(this.drain.id)) {
                return {
                    url: '/images/map-pin-purple.png',
                    scaledSize: { width: 27, height: 39 },
                };
            }

            if (this.adoptedDrainIds.includes(this.drain.id)) {
                return {
                    url: '/images/map-pin-blue.png',
                    scaledSize: { width: 27, height: 39 },
                };
            }

            return {
                url: '/images/map-pin-yellow.png',
                scaledSize: { width: 27, height: 39 },
            };
        },
    },

    methods: {
        closeInfoBox() {
            this.showInfo = false;
        },
        openInfoBox() {
            this.showInfo = true;
            this.$emit('drainOpened', this.drain.id);
        }
    },

    watch: {
        openedDrainId() {
            if (this.showInfo && this.openedDrainId != this.drain.id) {
                this.$refs.infoPopup.infoWindow.close();
                this.showInfo = false;
            }
        }
    },
};
</script>
